






























































































































import {
  Component,
  Vue,
  Prop,
  Emit,
} from 'vue-property-decorator';
import ProfileConnector from '@/connector/Profile.vue';
import DialogConnector from '@/connector/Dialog.vue';
import BaseDataTable from '@/components/BaseDataTable.vue';
import AuthConnector from '@/connector/Auth.vue';
import moment from 'moment';

@Component({
  components: {
    AuthConnector,
    ProfileConnector,
    BaseDataTable,
    DialogConnector,
  },
})
export default class LoginDialog extends Vue {
  @Prop({ type: Boolean, required: true }) open: boolean|undefined;

  public depositAmount: number = 0;

  public withdrawAmount: number = 0;

  public affiliateGain: number = 0;

  get dialog() {
    return this.open;
  }

  set dialog(value) {
    this.close();
  }

  @Emit('close-dialog')
  // eslint-disable-next-line class-methods-use-this
  close() {
    return false;
  }

  public amount: number = 0;

  public loading: boolean = false;

  // eslint-disable-next-line class-methods-use-this
  get myTransactionEndpoint() {
    return `${process.env.VUE_APP_API_ENDPOINT}/transactions/me`;
  }

  // eslint-disable-next-line class-methods-use-this
  get currentWeek() {
    return moment().week();
  }

  // eslint-disable-next-line class-methods-use-this
  get currentYear() {
    return moment().year();
  }

  // eslint-disable-next-line class-methods-use-this
  get transactionRange() {
    return `${moment().startOf('week').format('YYYY-MM-DD')},${moment().endOf('week').format('YYYY-MM-DD')}`;
  }

  // eslint-disable-next-line class-methods-use-this
  getStartAndEndOfWeek(week: number) {
    const current = moment().week(week);
    const format = 'YYYY-MM-DD';
    return `${current.startOf('week').format(format)} ถึง ${current.endOf('week').format(format)}`;
  }
}
